import React from "react";
import Chart from "react-apexcharts";
import { normalizeTimelineForChart } from "../LinkHelper";


export const OverallActivityChart = ({ timeline = [], range = "all-time" }) => {
  const { labels, clicks, streams } = normalizeTimelineForChart(timeline, range);

  const series = [
    {
      name: "Page Views",
      data: clicks
    },
    {
      name: "Streaming Link Clicks",
      data: streams
    }
  ];

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    stroke: {
      curve: "smooth",
      width: 2
    },
    markers: {
      size: 4,
      hover: { size: 6 }
    },
    colors: ["#7C83FD", "#2ED47A"],
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 4
    },
    xaxis: {
      categories: labels,
      labels: {
        rotate: -45,
        style: { colors: "#00067e", fontSize: "12px" }
      }
    },
    yaxis: {
      min: 0,
      labels: {
        style: { colors: "#00067e", fontSize: "12px" }
      }
    },
    legend: {
      position: "top",
      fontWeight: 600
    },
    tooltip: {
      shared: true,
      intersect: false
    }
  };

  return (
    <div className="bg-white border-2 border-theme_clr1 rounded-2xl p-4">
      <Chart options={options} series={series} type="line" height={300} />
    </div>
  );
};